import { Component, Inject, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";


export interface AlertData {
	mensaje: string;
	text: boolean;
	title: string;
	mensajeHtml: string;
}

@Component({
	selector: "p-alert",
	templateUrl: "./confirm-points.component.html",
	styleUrls: ["./confirm-points.component.scss", "../../pages/action-points/action-points.component.scss"]
})
export class ConfirmPointsComponent {

	@ViewChild("textarea") textarea: any;

	public constructor(
		@Inject(MAT_DIALOG_DATA) public data: AlertData,
		public dialogRef: MatDialogRef<ConfirmPointsComponent>) {
	}

	public ok(): void {
		if (this.data.text) {
			this.dialogRef.close({
				result: "ok",
				text: this.textarea.nativeElement.value,
			});
		}
		else {
			this.dialogRef.close("ok");
		}
	}

	public onNoClick(): void {
		this.dialogRef.close();
	}
}
